import { render } from "./TraitRanksMethDisclaimer.vue?vue&type=template&id=12e9957a"
import script from "./TraitRanksMethDisclaimer.vue?vue&type=script&lang=js"
export * from "./TraitRanksMethDisclaimer.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__